const dlsDeepBlueBg = {
  "backgroundColor": "#00175a !important"
};

export { dlsDeepBlueBg };
